module.exports = __webpack_public_path__ + "assets/images/not_ok.png";